<template>
  <div class="crime-wrapper owl-theme owl-carousel" ref="owlCarousel">
    <GameRow v-for="item in items"
      :key="item.id" :game="item" />
  </div>
</template>

<script>
import { onMounted, onBeforeUnmount, ref, watch, nextTick } from "vue";
import "owl.carousel";
import $ from "jquery";
import GameRow from "@/components/partials/GameRow.vue";

export default {
  name: "MostViewsCarousel",
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  components: {
    GameRow,
  },
  setup(props) {
    const owlCarousel = ref(null);

    const destroyCarousel = () => {
      if (owlCarousel.value && $(owlCarousel.value).hasClass("owl-loaded")) {
        $(owlCarousel.value).trigger("destroy.owl.carousel");
        $(owlCarousel.value).removeClass("owl-loaded owl-drag");
      }
    };

    const initializeCarousel = () => {
      // Destroy and reinitialize the carousel if it's already initialized
      destroyCarousel();

      $(owlCarousel.value).owlCarousel({
        loop: true,
        margin: 10,
        smartSpeed: 2500,
        autoplayTimeout: 2500,
        autoplay: false,
        nav: true,
        dots: false,
        responsiveClass: true,
        navText: $('html').attr('dir') === 'rtl'? [
          '<i class="fas fa-chevron-right"></i>',
          '<i class="fas fa-chevron-left"></i>',
        ] : [
          '<i class="fas fa-chevron-left"></i>',
          '<i class="fas fa-chevron-right"></i>',
        ],
        rtl: $('html').attr('dir') === 'rtl',
        responsive: {
          0: {
            items: 1,
          },
          575: {
            items: 2,
          },
          767: {
            items: 2,
          },
          991: {
            items: 3,
          },
          1199: {
            items: 2,
          },
          1499: {
            items: 3,
          },
          1999: {
            items: 3,
          },
        },
      });
    };

    // Initialize the carousel on mount
    onMounted(() => {
      nextTick(() => {
        initializeCarousel();
      });
    });

    // Clean up carousel on unmount to prevent memory leaks
    onBeforeUnmount(() => {
      destroyCarousel();
    });

    // Watch for changes in the `items` prop and reinitialize the carousel if necessary
    watch(
      () => props.items,
      (newItems, oldItems) => {
        if (newItems !== oldItems) {
          nextTick(() => {
            initializeCarousel();
          });
        }
      }
    );

    return {
      owlCarousel,
    };
  },
};
</script>
